// sortAndfilter.service.ts
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root' // ensures singleton
})
export class SortAndFilterService {
    private filterParams: any = {};
    private sortParams: any = {};

    setFilters(key: string, params: any) {
        this.filterParams[key] = params;
    }

    getFilters(key: string): any {
        return this.filterParams[key];
    }

    clearFilters(key: string) {
        this.filterParams[key] = null;
    }

    setSort(key:string, params: any) {
        this.sortParams[key] = params;
    }

    getSort(key: string): any {
        return this.sortParams[key];
    }


    clearSort(key: string) {
        this.sortParams[key] = null;
    }

    resetAllFilters() {
        this.filterParams = {};
    }

    resetAllSorts() {
        this.sortParams = {};
    }



}
